import { GridColumns, GridEnrichedColDef, GridEventListener, GridRowId, GridRowParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import React, { ReactElement } from 'react'
import { Flex } from 'src/styles/flexComponent'
import TableDataCard from './TableDataCard'
import { DialogContextType } from 'src/enums'
interface IMobileCardList {
  columns: GridColumns[] | GridEnrichedColDef<any, any, any>[]
  rows: any[]
  contextType?: DialogContextType
  mobileViewCard?: (row: any) => ReactElement
  getDetailPanelContent?: ((params: GridRowParams<any>) => React.ReactNode) | undefined
  onRowClick: GridEventListener<'rowClick'> | undefined
  onCellClick?: GridEventListener<'cellClick'> | undefined
  getRowId?: (row: GridValidRowModel) => GridRowId
}

const MobileCardList: React.FC<IMobileCardList> = props => {
  const { rows, ...rest } = props

  return (
    <Flex.Column padding={0}>
      {rows.map((row, index) => (
        <TableDataCard key={index} row={row} {...rest} />
      ))}
    </Flex.Column>
  )
}

export default MobileCardList